import React, { useState } from "react";
import { Card, Dropdown, Form } from "react-bootstrap";
import { FiStar } from "react-icons/fi";
import { BsGrid3X3Gap } from "react-icons/bs";

export default function EmployeeTasksCard() {

const [filter,setFilter] = useState("All Projects");
const [checked,setChecked] = useState({});

const tasks = [
{
id:1,
title:"Patient appointment booking",
status:"Onhold",
color:"pink",
avatars:["avatar-13-1.jpg","avatar-14-1.jpg","avatar-15-1.jpg"]
},
{
id:2,
title:"Appointment booking with payment",
status:"Inprogress",
color:"purple",
avatars:["avatar-20-1.jpg","avatar-21-1.jpg"]
},
{
id:3,
title:"Patient and Doctor video conferencing",
status:"Completed",
color:"green",
avatars:["avatar-28-1.jpg","avatar-29-1.jpg","avatar-24-1.jpg"]
},
{
id:4,
title:"Private chat module",
status:"Pending",
color:"blue",
avatars:["avatar-23-1.jpg","avatar-24-1.jpg","avatar-25-1.jpg"]
},
{
id:5,
title:"Go-Live and Post-Implementation Support",
status:"Inprogress",
color:"purple",
avatars:["avatar-26-1.jpg","avatar-27-1.jpg"]
}
];

const filteredTasks =
filter === "All Projects"
? tasks
: tasks.filter(task => task.status === "Inprogress");

const toggleCheck = (id) => {
setChecked(prev => ({
...prev,
[id]: !prev[id]
}));
};

return(

<Card className="dashboard-card h-100">

<Card.Header className="d-flex justify-content-between align-items-center card-header-custom">

<h6 className="mb-0">Tasks</h6>

<Dropdown>

<Dropdown.Toggle variant="light" size="sm" className="project-btn">
{filter}
</Dropdown.Toggle>

<Dropdown.Menu align="end">

<Dropdown.Item onClick={()=>setFilter("All Projects")}>
All Projects
</Dropdown.Item>

<Dropdown.Item onClick={()=>setFilter("Ongoing Projects")}>
Ongoing Projects
</Dropdown.Item>

</Dropdown.Menu>

</Dropdown>

</Card.Header>

<Card.Body>

{filteredTasks.map((task)=>(
<div key={task.id} className="task-item">

<div className="left">

<span className="drag-icon">
<BsGrid3X3Gap/>
</span>

<Form.Check
type="checkbox"
className="check"
checked={checked[task.id] || false}
onChange={()=>toggleCheck(task.id)}
/>

<FiStar className="star"/>

<span className={`task-title ${checked[task.id] ? "done" : ""}`}>
{task.title}
</span>

</div>

<div className="right">

<span className={`status-badge ${task.color}`}>
<span className="dot"></span>
{task.status}
</span>

<div className="avatar-group">

{task.avatars.map((a,i)=>(
<img
key={i}
src={`/assets/img/profiles/${a}`}
alt=""
/>
))}

</div>

</div>

</div>
))}

</Card.Body>

<style>{`

.dashboard-card{
border-radius:5px;
border:2px solid #e5e7eb;
}


      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
.task-item{
border:1px solid #e5e7eb;
border-radius:8px;
padding:9px 13px;
display:flex;
justify-content:space-between;
align-items:center;
margin-bottom:13px;
background:#fff;
}

.left{
display:flex;
align-items:center;
}

.drag-icon{
color:#9ca3af;
margin-right:8px;
font-size:15px;
cursor:grab;
}

.check{
margin-right:8px;
}

.star{
margin-right:8px;
color:#f59e0b;
font-size:14px;
}

.task-title{
font-size:15px;
font-weight:500;
color:#1f2937;
}

.task-title.done{
text-decoration:line-through;
color:#9ca3af;
}

.right{
display:flex;
align-items:center;
gap:10px;
}

.status-badge{
display:flex;
align-items:center;
gap:5px;
padding:4px 10px;
border-radius:20px;
font-size:11px;
font-weight:500;
}

.status-badge .dot{
width:6px;
height:6px;
border-radius:50%;
display:inline-block;
}

.pink{
background:#ffe4ec;
color:#ec4899;
}
.pink .dot{ background:#ec4899; }

.purple{
background:#f3e8ff;
color:#9333ea;
}
.purple .dot{ background:#9333ea; }

.green{
background:#dcfce7;
color:#16a34a;
}
.green .dot{ background:#16a34a; }

.blue{
background:#e0f2fe;
color:#0284c7;
}
.blue .dot{ background:#0284c7; }

.avatar-group{
display:flex;
align-items:center;
}

.avatar-group img{
width:24px;
height:24px;
border-radius:50%;
border:2px solid #fff;
margin-left:-6px;
object-fit:cover;
}

.project-btn{
border:1px solid #e5e7eb;
font-size:12px;
}

`}</style>

</Card>

)

}